import React, { useCallback, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider, useAuth } from '../features/auth/context/AuthContext';
import LoginPage from '../pages/LoginPage';
import Header from './layout/Header';
import KeyboardShortcutsHelp from './layout/KeyboardShortcutsHelp';
import SearchPalette from './layout/SearchPalette';
import AppRoutes from './AppRoutes';
import { useGlobalShortcuts } from './useGlobalShortcuts';

function SignedInApp() {
  const [shortcutsOpen, setShortcutsOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const openSearch = useCallback(() => setSearchOpen(true), []);
  const openShortcuts = useCallback(() => setShortcutsOpen(true), []);
  useGlobalShortcuts({ onSearch: openSearch, onHelp: openShortcuts });

  return (
    <>
      <Header />
      <main>
        <AppRoutes />
      </main>
      <KeyboardShortcutsHelp isOpen={shortcutsOpen} onClose={() => setShortcutsOpen(false)} />
      <SearchPalette isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}

function AuthGate() {
  const { user } = useAuth();
  return user ? <SignedInApp /> : <LoginPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthGate />
      </AuthProvider>
    </BrowserRouter>
  );
}
